export const CalculateCount = (event, sortedResults) => {
    //minimum number to be in top places
    const minNumToAward = event.minimumNumberToAward;
    //when competitors exceeds the min amount , the percentage of competitors takes the top place
    const precentage = event.percentageToAward;

    const competitorsCount = sortedResults.length

    if (competitorsCount <= minNumToAward) {
        return competitorsCount
    } else {
        const count = Math.round((precentage / 100) * competitorsCount);
        const topPlaces = sortedResults.filter(result => result?.overallPosition <= sortedResults[count - 1]?.overallPosition)
        return topPlaces.length;
    }
}

// Rows a results table shows. The server now trims published results itself
// (placers only, plus the viewer's own dancers; the full field for a teacher
// with a dancer in the competition) and sends its placer count, so re-cutting
// the already-trimmed list here would shrink it again. Without a server count,
// fall back to the old client-side cut.
export const visibleRows = (event, sortedResults, placerCount, fullField) => {
    const count = Number.isFinite(placerCount) ? placerCount : (event ? CalculateCount(event, sortedResults) : 0);
    return { count, rows: fullField ? sortedResults : sortedResults.slice(0, count) };
}
